/**
 * 抽奖 / 节日礼包 / 活动 / 分区（含 /err 错误页）
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/lucky_wheel',
    name: 'luckyWheel',
    component: () =>
      import(
        /* webpackChunkName: "bindCard" */
        '@/views/luckyWheel/index.vue'
      ),
    meta: {
      title: '幸运大转盘'
    }
  },
  {
    path: '/lucky/exchange',
    name: 'exchange',
    component: () =>
      import(
        /* webpackChunkName: "card" */
        '@/views/luckyWheel/exchange.vue'
      ),
    meta: {
      title: '结算',
      isCommon: true
    }
  },
  {
    path: '/festival_channel',
    name: 'festival_channel',
    component: () =>
      import(
        /* webpackChunkName: "festival" */
        '@/views/festival/index.vue'
      ),
    meta: {
      title: '节日礼包',
      is_festivalPop: true
    }
  },
  {
    path: '/pc_activity',
    name: 'pc_activity',
    component: () =>
      import(
        /* webpackChunkName: "festival" */
        '@/views/festival/pc_activity.vue'
      ),
    meta: {
      title: '礼包列表',
      is_festivalPop: true
    }
  },
  {
    path: '/pc_partition',
    name: 'pc_partition',
    component: () =>
      import(
        /* webpackChunkName: "festival" */
        '@/views/festival/pc_partition.vue'
      ),
    meta: {
      title: '礼包列表'
    }
  },
  {
    path: '/err',
    name: 'err',
    component: () =>
      import(
        /* webpackChunkName: "err" */
        '@/views/err/index.vue'
      ),
    meta: {
      title: '网络错误'
    }
  }
];
